import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const MagnifyingGlassIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/magnifying-glass"><path id="Icon" fillRule="evenodd" clipRule="evenodd" d="M10.8 4.1999C7.15495 4.1999 4.20002 7.15482 4.20002 10.7999C4.20002 14.445 7.15495 17.3999 10.8 17.3999C12.6228 17.3999 14.2716 16.6622 15.4669 15.4668C16.6623 14.2715 17.4 12.6227 17.4 10.7999C17.4 7.15482 14.4451 4.1999 10.8 4.1999ZM2.40002 10.7999C2.40002 6.16071 6.16083 2.3999 10.8 2.3999C15.4392 2.3999 19.2 6.16071 19.2 10.7999C19.2 12.7949 18.5037 14.6286 17.3421 16.0692L21.3364 20.0635C21.6879 20.415 21.6879 20.9848 21.3364 21.3363C20.985 21.6878 20.4151 21.6878 20.0636 21.3363L16.0693 17.342C14.6287 18.5035 12.7951 19.1999 10.8 19.1999C6.16083 19.1999 2.40002 15.4391 2.40002 10.7999Z" fill="currentColor" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default MagnifyingGlassIcon;